// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-583c53dc] .ant-form-item-children {\n  display: flex;\n  align-items: center;\n}\n[data-v-583c53dc] .ant-input-number-input {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
